import { render, staticRenderFns } from "./ShowDialog.vue?vue&type=template&id=1ef0976c&scoped=true"
import script from "./ShowDialog.vue?vue&type=script&lang=js"
export * from "./ShowDialog.vue?vue&type=script&lang=js"
import style0 from "./ShowDialog.vue?vue&type=style&index=0&id=1ef0976c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ef0976c",
  null
  
)

export default component.exports